import { frequencyType } from '@/constants/enums/orderNew';
import { daysDiffCalculator } from '@/lib/utils';
import moment from 'moment';

export function calculateExistingItemPrice(cartItems: any) {
  return cartItems?.reduce((total: number, cartItem: any) => {
    const { cardData } = cartItem;
    return total + (cardData?.price || 0) * cartItem?.quantity;
  }, 0);
}

export function calculateEstimatedImage(data: any, frequencyList: any) {
  let id = data?.uu_id;
  let startDate = moment(data?.startDate).startOf('day');
  let lastDate = moment(data?.lastDate).startOf('day');

  let frequency =
    data?.frequency === frequencyType.ONE_TIME
      ? daysDiffCalculator(startDate, lastDate)
      : parseInt(data?.frequency);
  let interval = calculateInterval(frequencyList, data?.originalFrequency);
  let totalDays = lastDate.diff(startDate, 'days') + 1;
  let estimatedImageCount: any;
  const initialCalculation = totalDays / frequency;
  const calculation = Math.round(initialCalculation);

  if (initialCalculation > 1) {
    if (initialCalculation > calculation) {
      estimatedImageCount = calculation + 1;
    } else {
      estimatedImageCount = calculation;
    }
  } else {
    estimatedImageCount = calculation < 1 ? 1 : calculation;
  }

  return {
    ...data,
    id,
    estimatedImageCount,
    interval,
    frequency,
    originalFrequency: data.frequency,
  };
}

export function calculateInterval(frequencyList: any, frequency: any) {
  let updatedFrequency = frequency;
  if (frequency !== frequencyType.ONE_TIME) {
    updatedFrequency = parseInt(frequency);
  }

  const newFrequency = frequencyList.filter((data: any) => data.value === updatedFrequency);
  if (newFrequency?.length === 0) {
    return frequencyType.ONE_TIME;
  } else {
    return newFrequency?.[0]?.label;
  }
}
